import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";

import { getDb } from "../../../../lib/firestore.ts";

interface LiveProgress {
  summary: string;
  keyPoints: string[];
}

/**
 * Running interview summary, refreshed ~once a minute by the backend and shown
 * live so the interviewer always sees where the conversation stands.
 */
export function InterviewLiveSummaryPanel({ meetingId }: { meetingId: string }) {
  const [progress, setProgress] = useState<LiveProgress | null>(null);

  useEffect(() => {
    try {
      const ref = doc(getDb(), "meetings", meetingId, "interviewProgress", "latest");
      const unsub = onSnapshot(
        ref,
        (snap) => {
          const d = snap.data() as LiveProgress | undefined;
          setProgress(d ?? null);
        },
        () => setProgress(null),
      );
      return () => unsub();
    } catch {
      /* firestore unavailable */
    }
  }, [meetingId]);

  return (
    <section className="panel" style={{ minHeight: 0 }}>
      <div className="panel-head">
        <div style={{ fontWeight: 600, fontSize: 13 }}>Live summary</div>
      </div>
      <div style={{ padding: "8px 12px", overflowY: "auto" }}>
        {!progress ? (
          <p style={{ fontSize: 12, color: "var(--text-3)", margin: "4px 0" }}>
            A running summary of the interview will appear here (updates ~every minute).
          </p>
        ) : (
          <>
            <p style={{ fontSize: 13, margin: "0 0 8px", lineHeight: 1.5 }}>{progress.summary}</p>
            {progress.keyPoints.length > 0 && (
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {progress.keyPoints.map((k, i) => (
                  <li key={i} style={{ fontSize: 12, color: "var(--text-2)", padding: "1px 0" }}>
                    {k}
                  </li>
                ))}
              </ul>
            )}
          </>
        )}
      </div>
    </section>
  );
}
